<template>
  <div class="misc-wrapper">

    <!-- 標題 -->
    <b-link class="brand-logo">
      <vuexy-logo />
      <h2 class="brand-text text-primary">
        曠世國際有限公司
      </h2>
    </b-link>

    <!-- 內容 -->
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">

        <h2 class="mb-1 ">
          找不到網頁 🕵🏻‍♀️
        </h2>
        <p class="mb-2">
          糟糕! 😖 在此服務器上找不到請求的URL。
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="{path:'/'}"
        >
          返回首頁
          <font-awesome-icon icon="arrow-right" />
        </b-button>

        <b-img
          fluid
          :src="imgUrl"
          alt="Error page"
        />
      </div>
    </div>

  </div>
</template>

<script>

import { BLink, BButton, BImg } from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'

export default {
  components: {
    VuexyLogo,
    BLink,
    BButton,
    BImg,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/error.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
